import { useState, useEffect } from "react"
import { createPaymentSession } from "../endpoints/api"
import { MoonLoader } from "react-spinners"
import { loadStripe } from "@stripe/stripe-js"
import Tune1 from "../assets/images/Tune1.png"
import Tune2 from "../assets/images/Tune2.png"
import People from "../assets/images/People.png"

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY)

const PriceCard = ({ clicked, setClicked, setLoading, userInfo, recordClick }) => {
  const handlePaymentClick = async (e, user) => {
    e.preventDefault()
    setClicked(true)
    recordClick(userInfo?.uuid || "", userInfo?.email || "")
    setLoading(true)
    try {
      let fromMusicnerd = false
      if (window && window.location && window.location.href && window.location.href.includes("musicnerd.io")) {
        fromMusicnerd = true
      }
      const resp = await createPaymentSession(user.uuid, user.email, "LEGACY", fromMusicnerd)
      if (resp && resp.data) {
        const sessionId = resp.data.sessionId
        if (!sessionId) {
          throw new Error("Couldn't find checkout session")
        }
        // Redirect to Stripe Checkout
        const stripe = await stripePromise
        const { error } = await stripe.redirectToCheckout({
          sessionId,
        })

        if (error) {
          console.error("Stripe Checkout Error:", error)
        }
      } else {
        throw new Error("Couldn't create payment session")
      }
    } catch (error) {
      console.log("Error opening payment", error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="mt-0 w-full flex flex-col justify-center items-center">
      <div className="w-[80%] sm:w-[70%] md:w-[60%] rounded-[30px] p-[2px] overflow-hidden relative">
        <div className="absolute inset-0 bg-gradient-to-br from-[#3BB4E8] via-[#529A36] to-[#FEC330] rounded-[30px]"></div>
        <button
          className="relative w-full bg-[#0A0B0D] rounded-[28px] py-1.5 sm:py-2 flex items-center justify-center text-xs sm:text-sm"
          disabled={clicked}
          onClick={(e) => handlePaymentClick(e, userInfo)}
        >
          Upgrade to Pro
        </button>
      </div>
    </div>
  )
}

const PricingModal = ({ userInfo, recordClick }) => {
  const [clicked, setClicked] = useState(false)
  const [loading, setLoading] = useState(false)
  const [timerString, setTimerString] = useState("")

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date()
      const midnight = new Date()

      midnight.setHours(24, 0, 0, 0)

      const difference = midnight - now

      const hours = Math.floor(difference / (1000 * 60 * 60))
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = Math.floor((difference % (1000 * 60)) / 1000)

      return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
    }

    setTimerString(calculateTimeLeft())

    const timer = setInterval(() => {
      setTimerString(calculateTimeLeft())
    }, 1000)

    return () => clearInterval(timer)
  }, [])

  return (
    <div style={{ zIndex: 100 }} className="fixed inset-0 flex h-screen items-center justify-center bg-[#141A1E]">
      <div className="w-[90%] md:h-[85%] h-[80%] sm:w-[70%] md:w-[50%] lg:w-[40%] max-w-[500px] flex flex-col items-center justify-center bg-payment-modal bg-cover rounded-[24px] px-3 py-4 sm:py-6 text-white">
        
        <div className="w-full flex flex-col items-center justify-center gap-3">
          <p className="text-[#FFC331] text-xs sm:text-sm font-semibold">That's 20 Plays! You Crushed It!</p>
          <h2 className="text-white fira-sans-extrabold text-lg sm:text-2xl leading-5 sm:leading-6 text-center tracking-wider">
            WANNA KEEP THE <br /> STREAK GOING?
          </h2>
          <div className="flex flex-col items-center justify-center">
            <p className="text-white text-xs sm:text-sm">Come Back for 20 Free Quizzes</p>
            <p className="text-white text-sm sm:text-base font-bold mb-2">{timerString}</p>
          </div>

          <div className="relative w-[80%] sm:w-[60%]">
            {/* Top button that straddles the border */}
            <div
              className="absolute top-0 left-0 right-0 flex items-center justify-center z-10"
              style={{ transform: "translateY(-14px)" }}
            >
              <div className="w-28 sm:w-32 h-7 sm:h-8 rounded-full overflow-hidden">
                <button className="w-full h-full bg-gradient-to-r from-[#C8B9F9] via-[#FD3535] to-[#FEC330] flex items-center justify-center">
                  <span className="text-black fira-sans-extrabold text-xs sm:text-sm">MUZIFY PRO</span>
                </button>
              </div>
            </div>

            {/* Main container with gradient border */}
            <div className="relative p-[2px] bg-black rounded-[16px] overflow-hidden z-0">
              <div className="absolute inset-0 bg-gradient-to-br from-[#C8B9F9] via-[#FD3535] to-[#FEC330] rounded-[16px] z-0" />
              <div className="relative bg-[#0A0B0D] rounded-[14px] flex flex-col items-center z-10 p-3 sm:p-4">
                <div className="w-full mt-2">
                  <div className="flex flex-row mb-0 relative min-h-[80px] sm:min-h-[100px]">
                    <div className="relative w-[80px] sm:w-[90px] h-[80px] sm:h-[100px]">
                      <div className="absolute left-[30px] sm:left-[30px] top-[5px] z-10 w-16 sm:w-20 h-16 sm:h-20">
                        <img
                          src={Tune2 || "/placeholder.svg"}
                          alt="Music note"
                          className="w-[60px] sm:w-[80px] h-[60px] sm:h-[80px] object-contain"
                        />
                      </div>
                      <div className="absolute left-[-5px] top-[-3px] w-20 sm:w-24 h-20 sm:h-24 z-0">
                        <img
                          src={Tune1 || "/placeholder.svg"}
                          alt="Music note"
                          className="w-[80px] sm:w-[100px] h-[90px] sm:h-[100px] object-contain"
                        />
                      </div>
                    </div>
                    <div className="ml-1 sm:ml-2">
                      <div className="flex flex-row items-start mb-1 sm:mb-2">
                        <span className="text-[#FFC331] text-sm sm:text-base mr-1 sm:mr-2">✦</span>
                        <span className="text-white text-xs sm:text-sm">
                          Unlimited Quizzes
                          <br />
                          for Unlimited Artists
                        </span>
                      </div>

                      <div className="flex flex-row items-start mb-1 sm:mb-2">
                        <span className="text-[#FFC331] text-sm sm:text-base mr-1 sm:mr-2">✦</span>
                        <span className="text-white text-xs sm:text-sm">AD Free Experience</span>
                      </div>

                      <div className="flex flex-row items-start">
                        <span className="text-[#FFC331] text-sm sm:text-base mr-1 sm:mr-2">✦</span>
                        <span className="text-white text-xs sm:text-sm">Unlock a Secret Invite</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="w-full flex flex-col items-center mb-1">
                  <p className="text-white text-xs sm:text-sm fira-sans-regular my-2 mb-0.5">Introductory Offer</p>
                  <div className="flex flex-col items-center justify-center">
                    <p className="text-white text-xs sm:text-sm line-through">$5.99</p>
                    <div className="flex flex-row items-center justify-center">
                      <span className="text-white fira-sans-bold text-xs sm:text-sm mr-1">ONLY</span>
                      <span className="text-white fira-sans-extrabold text-base sm:text-lg">$3.99</span>
                    </div>
                  </div>
                </div>

                {loading ? (
                  <div className="py-2">
                    <MoonLoader size={40} color="#FFFFFF" />
                  </div>
                ) : (
                  <PriceCard
                    clicked={clicked}
                    setClicked={setClicked}
                    setLoading={setLoading}
                    userInfo={userInfo}
                    recordClick={recordClick}
                  />
                )}

                <div className="flex flex-col items-center justify-center">
                  <div className="w-[80px] sm:w-[100px]">
                    <img src={People || "/placeholder.svg"} alt="People" className="w-full mt-2 h-auto object-contain" />
                  </div>
                  <p className="text-white text-center text-[10px] mt-2 sm:text-xs leading-tight">
                    7000+ fans have already upgraded to Muzify Pro
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PricingModal
